import _get from 'lodash/get';
import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import { ASSESSMENT_COLORS } from 'containers/Assessment/constants';
import TakeArrowWhite from 'containers/Assessments/images/assessment-arrow-white.svg';
import TakeArrowBlack from 'containers/Assessments/images/assessment-arrow-black.svg';
import AssessmentWhiteIcon from 'components/Resources/images/White/Assessments.svg';
import AssessmentBlackIcon from 'components/Resources/images/Black/Assessments.svg';

export const isAssessmentSaved = (savedAssessments, assessment) => {
  const id =
    _get(assessment, 'id') ||
    _get(assessment, 'sys.id') ||
    _get(assessment, 'objectID') ||
    '';
  return savedAssessments && savedAssessments.map(el => el.sys.id).includes(id);
};

export const isAssessmentTaken = (takenAssessments, assessment) => {
  const slug = _has(assessment, 'slug')
    ? assessment.slug
    : _has(assessment, 'fields')
    ? assessment.fields.slug
    : '';
  const id = _has(assessment, 'id')
    ? assessment.id
    : _has(assessment, 'sys')
    ? assessment.sys.id
    : '';
  return (
    (!_isEmpty(takenAssessments) &&
      Boolean(slug) &&
      takenAssessments.map(el => el.assessment.slug).includes(slug)) ||
    (!_isEmpty(takenAssessments) &&
      Boolean(id) &&
      takenAssessments.map(el => el.assessment.assessmentID).includes(id))
  );
};
// default to aqua in case of broken data
export const getColorsConfig = item => {
  const colorName = _get(item, 'fields.color') || _get(item, 'color');

  if (colorName) {
    const lowerCasedName = colorName.toLowerCase();
    const isWhite = ['aqua', 'gold', 'blue', 'grey'].includes(lowerCasedName);
    const takeArrowSvg = isWhite ? TakeArrowWhite : TakeArrowBlack;
    const checkSvg = isWhite ? AssessmentWhiteIcon : AssessmentBlackIcon;

    return {
      color: ASSESSMENT_COLORS[lowerCasedName],
      colorName,
      takeArrowSvg,
      checkSvg,
    };
  }

  return {
    color: ASSESSMENT_COLORS.aqua,
    colorName: 'aqua',
    takeArrowSvg: TakeArrowWhite,
    checkSvg: AssessmentWhiteIcon,
  };
};

export const filterClientExclusiveAssessment = ({
  assessments,
  clientShortName,
}) =>
  assessments.filter(field => {
    const isContentful = _has(field, 'fields');
    const isSearchIndex = _has(field, 'clients');
    let clientsShortName = [];
    if (isContentful) {
      clientsShortName = _get(field, 'fields.client', []).map(clientFields =>
        _get(clientFields, 'fields.shortName'),
      );
    } else if (isSearchIndex) {
      clientsShortName = _get(field, 'clients', []).filter(
        name => name !== 'none',
      );
    } else {
      clientsShortName = _get(field, 'client', [])
        .map(clientFields => _get(clientFields, 'shortName'))
        .filter(name => name !== 'none');
    }
    return !clientShortName
      ? !clientsShortName.length
      : !clientsShortName.length || clientsShortName.includes(clientShortName);
  });
